export default __webpack_public_path__ + "static/media/1.b6f53ff3.mp4";